import React, { useState, createContext, useContext } from "react";
import NotificationContainer from "../components/Notification/NotificationContainer";

//* context global management of notification
const NotificationContext = createContext();

//* provider
export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  //* add notification
  const createNotification = (status, title, description) => {
    const id = Date.now();
    setNotifications((prev) => [...prev, { id, title, description, status }]);

    //* remove notification
    setTimeout(() => {
      setNotifications((prev) => prev.filter((n) => n.id !== id));
    }, 5000);
  };

  return (
    <NotificationContext.Provider value={createNotification}>
      {children}
      <NotificationContainer notifications={notifications} />
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => {
  const createNotification = useContext(NotificationContext);
  if (!createNotification) {
    throw new Error(
      "useNotifications must be used within a NotificationProvider"
    );
  }
  return createNotification;
};
